module.exports = __webpack_public_path__ + "img/company_phone-16.19009b8f.svg";